import styled from 'styled-components'

export const RotatingContainer = styled.div<{isExpanded: boolean}>`
    position: absolute;

    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    transition: transform 0.2s ease-in-out;
    transform: ${({isExpanded}) => (isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)')};
`

export const ExpandIconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 14px;
    height: 14px;
`
